<template>
  <svg
    class="p-icon-header-coupon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    fill="none"
    aria-hidden="true"
  >
    <g transform="translate(3.985 8.66)">
      <path
        class="p-icon-header-coupon__base"
        d="M25.85 0.0200005H2.17C0.98 0.0200005 0 0.99 0 2.19V7.51C0 8.06 0.45 8.51 1 8.51C1.47 8.51 1.84 8.89 1.84 9.35C1.84 9.81 1.46 10.19 1 10.19C0.45 10.19 0 10.64 0 11.19V16.51C0 17.7 0.97 18.68 2.17 18.68H25.86C27.05 18.68 28.03 17.71 28.03 16.51V2.17C28.03 0.98 27.06 0 25.86 0L25.85 0.0200005ZM26.02 16.52C26.02 16.61 25.95 16.69 25.85 16.69H8.65V14.42C8.65 13.87 8.2 13.42 7.65 13.42C7.1 13.42 6.65 13.87 6.65 14.42V16.69H2.17C2.08 16.69 2 16.62 2 16.52V12.01C3.08 11.6 3.84 10.56 3.84 9.35C3.84 8.14 3.07 7.09 2 6.69V2.18C2 2.09 2.07 2.01 2.17 2.01H6.65V4.28C6.65 4.83 7.1 5.28 7.65 5.28C8.2 5.28 8.65 4.83 8.65 4.28V2.01H25.86C25.95 2.01 26.03 2.08 26.03 2.18V16.52H26.02Z"
        fill="currentColor"
      />
      <path
        class="p-icon-header-coupon__fill"
        d="M25.85 0.0200005H2.17C0.98 0.0200005 0 0.99 0 2.19V7.51C0 8.06 0.45 8.51 1 8.51C1.47 8.51 1.84 8.89 1.84 9.35C1.84 9.81 1.46 10.19 1 10.19C0.45 10.19 0 10.64 0 11.19V16.51C0 17.7 0.97 18.68 2.17 18.68H25.86C27.05 18.68 28.03 17.71 28.03 16.51V2.17C28.03 0.98 27.06 0 25.86 0L25.85 0.0200005Z"
        fill="currentColor"
      />
      <path
        class="p-icon-header-coupon__dash"
        d="M6.65 2.01H8.65V4.28C8.65 4.83 8.2 5.28 7.65 5.28C7.1 5.28 6.65 4.83 6.65 4.28V2.01Z"
        fill="#ffffff"
      />
      <path
        class="p-icon-header-coupon__dash"
        d="M6.65 16.69V14.42C6.65 13.87 7.1 13.42 7.65 13.42C8.2 13.42 8.65 13.87 8.65 14.42V16.69H6.65Z"
        fill="#ffffff"
      />
      <path
        class="p-icon-header-coupon__separator"
        d="M7.65 7.06C7.1 7.06 6.65 7.51 6.65 8.06V10.64C6.65 11.19 7.1 11.64 7.65 11.64C8.2 11.64 8.65 11.19 8.65 10.64V8.06C8.65 7.51 8.2 7.06 7.65 7.06Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.p-icon-header-coupon {
  &__fill,
  &__dash {
    opacity: 0;
    transition: opacity $transition-sec--fast ease-in;
  }

  &__separator {
    transition: fill $transition-sec--fast ease-in;
  }
}
</style>
